import React, { Fragment } from 'react';
import { func, object } from 'prop-types';
import { CaretLeft, Close } from '@nike/nike-design-system-icons';
import { IconButton, TextStyled } from '@nike/nike-design-system-components';
import Link from '../Link';
import useBodega from '../../utils/hooks/bodegaHook';
import {
  MOBILE_MENU_CLOSE_BTN,
  SLIDE_OUT_CARET_CLASS,
  SLIDE_OUT_TITLE_CLASS,
  SLIDE_OUT_LINKS_CLASS,
  PANEL_TEXT_CLASS,
  PANEL_CONTROL_CLASS,
  PANEL_CONTENT_CLASS,
} from '../MobileMenu/styles';
import templateString from '../../utils/templateString';
import PanelLink from './panelLink';
import { BODEGA_DEFAULTS } from '../../constants';
import { StyledLink } from './styles';

const getSubMenuLabel = subMenu => {
  if (subMenu?.type === 'header' || subMenu?.type === 'link') return subMenu.label;
  if (!Array.isArray(subMenu.children)) return null;
  if (subMenu.children.length > 0) {
    return getSubMenuLabel(subMenu?.children[0]);
  }
};

/**
 * Mobile sub menu
 * @param {*} props
 * @param {object} props.panelItems from cms data
 * @param {func} props.closeMobileMenu
 * @param {func} props.closeSubMenu
 * @returns {React.ReactElement}
 */
const MobileMenuPanel = ({ panelItems, closeMobileMenu, closeSubMenu }) => {
  const closeMobileMenuKeyHandler = ({ nativeEvent }) => {
    switch (nativeEvent.which) {
      case 32: // SPACE
        closeMobileMenu();
        break;
      default:
        break;
    }
  };

  const previousBtnLabel = templateString(useBodega('nav_back_to', BODEGA_DEFAULTS.BACK_TO), {
    Category: panelItems.returnTo,
  });
  const closeMenuLabel = useBodega('nav_close_menu_aria_label', BODEGA_DEFAULTS.CLOSE_MENU);

  return (
    <Fragment>
      <div className={PANEL_CONTROL_CLASS}>
        <StyledLink
          ariaLabel={previousBtnLabel}
          className="previous__btn"
          data-id={panelItems.returnTo}
          onClick={() => {
            closeSubMenu();
          }}
        >
          <CaretLeft className={SLIDE_OUT_CARET_CLASS} />
          <TextStyled appearance="body1Strong" className={PANEL_TEXT_CLASS}>
            {panelItems.returnTo}
          </TextStyled>
        </StyledLink>
        <IconButton
          Icon={<Close />}
          ariaLabel={closeMenuLabel}
          background="dark"
          className={MOBILE_MENU_CLOSE_BTN}
          onClick={closeMobileMenu}
          onKeyDown={closeMobileMenuKeyHandler}
          size="small"
        />
      </div>
      <div className={PANEL_CONTENT_CLASS}>
        <TextStyled appearance="title3" className={SLIDE_OUT_TITLE_CLASS} color="primary">
          {panelItems.url ? (
            <Link href={panelItems.url}>{panelItems.title}</Link>
          ) : (
            panelItems.title
          )}
        </TextStyled>
        <div className={SLIDE_OUT_LINKS_CLASS}>
          {panelItems.childMenuItems?.map((subMenuItem, index) => {
            const linkLabel = getSubMenuLabel(subMenuItem);
            return (
              <PanelLink
                index={index}
                key={`${linkLabel}-${index}`}
                linkLabel={linkLabel}
                menuTitle={panelItems.title}
                subMenuItem={subMenuItem}
              />
            );
          })}
        </div>
      </div>
    </Fragment>
  );
};

export default MobileMenuPanel;

MobileMenuPanel.propTypes = {
  panelItems: object,
  closeMobileMenu: func,
  closeSubMenu: func,
};
